// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__uVCA9","row":"styles_row__2o1uG"};